import React from "react";
import { UploadSuccessMsg } from "./components";
import "./App.css";
import { AgGridReact } from "ag-grid-react";
import {
  ClientSideRowModelModule,
  ValidationModule,
  RowSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  PaginationModule,
} from "ag-grid-community";
import $ from "jquery";
import PropTypes from "prop-types";

class UploadAGgrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      columnDefs: [
        {
          headerName: "Student Id",
          field: "studentId",
          sortable: true,
          filter: true,
          pinned: "left",
        },
        {
          headerName: "First Name",
          field: "firstName",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Last Name",
          field: "lastName",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Given Name",
          field: "givenName",
          sortable: true,
          filter: true,
        },
        { headerName: "Grade", field: "grade", sortable: true, filter: true },
        {
          headerName: "Date Of Birth",
          field: "dateOfBirth",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Nationality",
          field: "nationality",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Primary Mobile Number",
          field: "primaryMobileNum",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Emergency Mobile Number",
          field: "emergencyMobileNum",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Address",
          field: "address",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Email Id1",
          field: "emailId1",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Email Id2",
          field: "emailId2",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Email Id3",
          field: "emailId3",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Emergency Contact Person",
          field: "emergencyContactPerson",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Admission Fees",
          field: "admissionFees",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Book Fees",
          field: "bookFees",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Canteen Fees",
          field: "canteenFees",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Division",
          field: "division",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Event Fee",
          field: "eventFee",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Extra Field1",
          field: "extraField1",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Extra Field2",
          field: "extraField2",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Extra Field3",
          field: "extraField3",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Extra Field4",
          field: "extraField4",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Extra Field5",
          field: "extraField5",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Father Name",
          field: "fatherName",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Mother Name",
          field: "motherName",
          sortable: true,
          filter: true,
        },
        { headerName: "Gender", field: "gender", sortable: true, filter: true },
        {
          headerName: "Medical Fees",
          field: "medicalFees",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Mobile Number",
          field: "mobileNum3",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Office Number",
          field: "mobileNum3",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Parent Id",
          field: "parentId",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Registration Fees",
          field: "registrationFees",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Residence Number",
          field: "residenceNum",
          sortable: true,
          filter: true,
        },
        {
          headerName: "School Fees",
          field: "schoolFees",
          sortable: true,
          filter: true,
        },
        {
          headerName: "School Id",
          field: "schoolId",
          sortable: true,
          filter: true,
        },
        {
          headerName: "School Name",
          field: "schoolName",
          sortable: true,
          filter: true,
        },
        {
          headerName: "School Phone Number",
          field: "schoolPhoneNum",
          sortable: true,
          filter: true,
        },
        {
          headerName: "School Trip Fees",
          field: "schoolTripeFees",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Secondary Mobile Number",
          field: "secondaryMobileNum",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Security Deposit Fees",
          field: "securityDepositFees",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Stationary Fees",
          field: "stationaryFees",
          sortable: true,
          filter: true,
        },
        // { headerName: "Student Registered", field: "studentRegistered", sortable: true, filter: true },
        {
          headerName: "Transportation Fees",
          field: "transportationFees",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Tuition Fees",
          field: "tuitionFees",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Uniform Fee",
          field: "uniformFee",
          sortable: true,
          filter: true,
        },
        { headerName: "Fee1", field: "fee1", sortable: true, filter: true },
        { headerName: "Fee2", field: "fee2", sortable: true, filter: true },
        { headerName: "Fee3", field: "fee3", sortable: true, filter: true },
        { headerName: "Fee4", field: "fee4", sortable: true, filter: true },
        { headerName: "Fee5", field: "fee5", sortable: true, filter: true },
        { headerName: "Fee6", field: "fee6", sortable: true, filter: true },
        { headerName: "Fee7", field: "fee7", sortable: true, filter: true },
        { headerName: "Fee8", field: "fee8", sortable: true, filter: true },
        { headerName: "Fee9", field: "fee9", sortable: true, filter: true },
        { headerName: "Fee10", field: "fee10", sortable: true, filter: true },
        { headerName: "Fee11", field: "fee11", sortable: true, filter: true },
        { headerName: "Fee12", field: "fee12", sortable: true, filter: true },
        { headerName: "Fee13", field: "fee13", sortable: true, filter: true },
        { headerName: "Fee14", field: "fee14", sortable: true, filter: true },
        { headerName: "Fee15", field: "fee15", sortable: true, filter: true },
        { headerName: "Fee16", field: "fee16", sortable: true, filter: true },
        { headerName: "Fee17", field: "fee17", sortable: true, filter: true },
        { headerName: "Fee18", field: "fee18", sortable: true, filter: true },
        { headerName: "Fee19", field: "fee19", sortable: true, filter: true },
        { headerName: "Fee20", field: "fee20", sortable: true, filter: true },
        { headerName: "Fee21", field: "fee21", sortable: true, filter: true },
        { headerName: "Fee22", field: "fee22", sortable: true, filter: true },
        { headerName: "Fee23", field: "fee23", sortable: true, filter: true },
        { headerName: "Fee24", field: "fee24", sortable: true, filter: true },
        { headerName: "Fee25", field: "fee25", sortable: true, filter: true },
        { headerName: "Fee26", field: "fee26", sortable: true, filter: true },
        { headerName: "Fee27", field: "fee27", sortable: true, filter: true },
        { headerName: "Fee28", field: "fee28", sortable: true, filter: true },
        { headerName: "Fee29", field: "fee29", sortable: true, filter: true },
        { headerName: "Fee30", field: "fee30", sortable: true, filter: true },
        { headerName: "Fee31", field: "fee31", sortable: true, filter: true },
        { headerName: "Fee32", field: "fee32", sortable: true, filter: true },
        { headerName: "Fee33", field: "fee33", sortable: true, filter: true },
        { headerName: "Fee34", field: "fee34", sortable: true, filter: true },
        { headerName: "Fee35", field: "fee35", sortable: true, filter: true },
        { headerName: "Fee36", field: "fee36", sortable: true, filter: true },
        { headerName: "Fee37", field: "fee37", sortable: true, filter: true },
        { headerName: "Fee38", field: "fee38", sortable: true, filter: true },
        { headerName: "Fee39", field: "fee39", sortable: true, filter: true },
        { headerName: "Fee40", field: "fee40", sortable: true, filter: true },
        { headerName: "Fee41", field: "fee41", sortable: true, filter: true },
        { headerName: "Fee42", field: "fee42", sortable: true, filter: true },
        { headerName: "Fee43", field: "fee43", sortable: true, filter: true },
        { headerName: "Fee44", field: "fee44", sortable: true, filter: true },
        { headerName: "Fee45", field: "fee45", sortable: true, filter: true },
        { headerName: "Fee46", field: "fee46", sortable: true, filter: true },
        { headerName: "Fee47", field: "fee47", sortable: true, filter: true },
        { headerName: "Fee48", field: "fee48", sortable: true, filter: true },
        { headerName: "Fee49", field: "fee49", sortable: true, filter: true },
        { headerName: "Fee50", field: "fee50", sortable: true, filter: true },
        { headerName: "Fee51", field: "fee51", sortable: true, filter: true },
        { headerName: "Fee52", field: "fee52", sortable: true, filter: true },
        { headerName: "Fee53", field: "fee53", sortable: true, filter: true },
        { headerName: "Fee54", field: "fee54", sortable: true, filter: true },
        { headerName: "Fee55", field: "fee55", sortable: true, filter: true },
        { headerName: "Fee56", field: "fee56", sortable: true, filter: true },
        { headerName: "Fee57", field: "fee57", sortable: true, filter: true },
        { headerName: "Fee58", field: "fee58", sortable: true, filter: true },
        { headerName: "Fee59", field: "fee59", sortable: true, filter: true },
        { headerName: "Fee60", field: "fee60", sortable: true, filter: true },
        { headerName: "Fee61", field: "fee61", sortable: true, filter: true },
        { headerName: "Fee62", field: "fee62", sortable: true, filter: true },
        { headerName: "Fee63", field: "fee63", sortable: true, filter: true },
        { headerName: "Fee64", field: "fee64", sortable: true, filter: true },
        { headerName: "Fee65", field: "fee65", sortable: true, filter: true },
        { headerName: "Fee66", field: "fee66", sortable: true, filter: true },
        { headerName: "Fee67", field: "fee67", sortable: true, filter: true },
        { headerName: "Fee68", field: "fee68", sortable: true, filter: true },
        { headerName: "Fee69", field: "fee69", sortable: true, filter: true },
        { headerName: "Fee70", field: "fee70", sortable: true, filter: true },
        { headerName: "Fee71", field: "fee71", sortable: true, filter: true },
        { headerName: "Fee72", field: "fee72", sortable: true, filter: true },
        { headerName: "Fee73", field: "fee73", sortable: true, filter: true },
        { headerName: "Fee74", field: "fee74", sortable: true, filter: true },
        { headerName: "Fee75", field: "fee75", sortable: true, filter: true },
        { headerName: "Fee76", field: "fee76", sortable: true, filter: true },
        { headerName: "Fee77", field: "fee77", sortable: true, filter: true },
        { headerName: "Fee78", field: "fee78", sortable: true, filter: true },
        { headerName: "Fee79", field: "fee79", sortable: true, filter: true },
        { headerName: "Fee80", field: "fee80", sortable: true, filter: true },
        { headerName: "Fee81", field: "fee81", sortable: true, filter: true },
        { headerName: "Fee82", field: "fee82", sortable: true, filter: true },
        { headerName: "Fee83", field: "fee83", sortable: true, filter: true },
        { headerName: "Fee84", field: "fee84", sortable: true, filter: true },
        { headerName: "Fee85", field: "fee85", sortable: true, filter: true },
        { headerName: "Fee86", field: "fee86", sortable: true, filter: true },
        { headerName: "Fee87", field: "fee87", sortable: true, filter: true },
        { headerName: "Fee88", field: "fee88", sortable: true, filter: true },
        { headerName: "Fee89", field: "fee89", sortable: true, filter: true },
        { headerName: "Fee90", field: "fee90", sortable: true, filter: true },
        { headerName: "Fee91", field: "fee91", sortable: true, filter: true },
        { headerName: "Fee92", field: "fee92", sortable: true, filter: true },
        { headerName: "Fee93", field: "fee93", sortable: true, filter: true },
        { headerName: "Fee94", field: "fee94", sortable: true, filter: true },
        { headerName: "Fee95", field: "fee95", sortable: true, filter: true },
        { headerName: "Fee96", field: "fee96", sortable: true, filter: true },
        { headerName: "Fee97", field: "fee97", sortable: true, filter: true },
        { headerName: "Fee98", field: "fee98", sortable: true, filter: true },
        { headerName: "Fee99", field: "fee99", sortable: true, filter: true },
        { headerName: "Fee100", field: "fee100", sortable: true, filter: true },
        { headerName: "Fee101", field: "fee101", sortable: true, filter: true },
        { headerName: "Fee102", field: "fee102", sortable: true, filter: true },
        { headerName: "Fee103", field: "fee103", sortable: true, filter: true },
        { headerName: "Fee104", field: "fee104", sortable: true, filter: true },
        { headerName: "Fee105", field: "fee105", sortable: true, filter: true },
        { headerName: "Fee106", field: "fee106", sortable: true, filter: true },
        { headerName: "Fee107", field: "fee107", sortable: true, filter: true },
        { headerName: "Fee108", field: "fee108", sortable: true, filter: true },
        { headerName: "Fee109", field: "fee109", sortable: true, filter: true },
        { headerName: "Fee110", field: "fee110", sortable: true, filter: true },
        { headerName: "Fee111", field: "fee111", sortable: true, filter: true },
        { headerName: "Fee112", field: "fee112", sortable: true, filter: true },
        { headerName: "Fee113", field: "fee113", sortable: true, filter: true },
        { headerName: "Fee114", field: "fee114", sortable: true, filter: true },
        { headerName: "Fee115", field: "fee115", sortable: true, filter: true },
        { headerName: "Fee116", field: "fee116", sortable: true, filter: true },
        { headerName: "Fee117", field: "fee117", sortable: true, filter: true },
        { headerName: "Fee118", field: "fee118", sortable: true, filter: true },
        { headerName: "Fee119", field: "fee119", sortable: true, filter: true },
        { headerName: "Fee120", field: "fee120", sortable: true, filter: true },
        { headerName: "Fee121", field: "fee121", sortable: true, filter: true },
        { headerName: "Fee122", field: "fee122", sortable: true, filter: true },
        { headerName: "Fee123", field: "fee123", sortable: true, filter: true },
        { headerName: "Fee124", field: "fee124", sortable: true, filter: true },
        { headerName: "Fee125", field: "fee125", sortable: true, filter: true },
        { headerName: "Fee126", field: "fee126", sortable: true, filter: true },
        { headerName: "Fee127", field: "fee127", sortable: true, filter: true },
        { headerName: "Fee128", field: "fee128", sortable: true, filter: true },
        { headerName: "Fee129", field: "fee129", sortable: true, filter: true },
        { headerName: "Fee130", field: "fee130", sortable: true, filter: true },
        { headerName: "Fee131", field: "fee131", sortable: true, filter: true },
        { headerName: "Fee132", field: "fee132", sortable: true, filter: true },
        { headerName: "Fee133", field: "fee133", sortable: true, filter: true },
        { headerName: "Fee134", field: "fee134", sortable: true, filter: true },
        { headerName: "Fee135", field: "fee135", sortable: true, filter: true },
        { headerName: "Fee136", field: "fee136", sortable: true, filter: true },
        { headerName: "Fee137", field: "fee137", sortable: true, filter: true },
        { headerName: "Fee138", field: "fee138", sortable: true, filter: true },
        { headerName: "Fee139", field: "fee139", sortable: true, filter: true },
        { headerName: "Fee140", field: "fee140", sortable: true, filter: true },
        { headerName: "Fee141", field: "fee141", sortable: true, filter: true },
        { headerName: "Fee142", field: "fee142", sortable: true, filter: true },
        { headerName: "Fee143", field: "fee143", sortable: true, filter: true },
        { headerName: "Fee144", field: "fee144", sortable: true, filter: true },
        { headerName: "Fee145", field: "fee145", sortable: true, filter: true },
        { headerName: "Fee146", field: "fee146", sortable: true, filter: true },
        { headerName: "Fee147", field: "fee147", sortable: true, filter: true },
        { headerName: "Fee148", field: "fee148", sortable: true, filter: true },
        { headerName: "Fee149", field: "fee149", sortable: true, filter: true },
        { headerName: "Fee150", field: "fee150", sortable: true, filter: true },
        { headerName: "Fee151", field: "fee151", sortable: true, filter: true },
        { headerName: "Fee152", field: "fee152", sortable: true, filter: true },
        { headerName: "Fee153", field: "fee153", sortable: true, filter: true },
        { headerName: "Fee154", field: "fee154", sortable: true, filter: true },
        { headerName: "Fee155", field: "fee155", sortable: true, filter: true },
        { headerName: "Fee156", field: "fee156", sortable: true, filter: true },
        { headerName: "Fee157", field: "fee157", sortable: true, filter: true },
        { headerName: "Fee158", field: "fee158", sortable: true, filter: true },
        { headerName: "Fee159", field: "fee159", sortable: true, filter: true },
        { headerName: "Fee160", field: "fee160", sortable: true, filter: true },
        { headerName: "Fee161", field: "fee161", sortable: true, filter: true },
        { headerName: "Fee162", field: "fee162", sortable: true, filter: true },
        { headerName: "Fee163", field: "fee163", sortable: true, filter: true },
        { headerName: "Fee164", field: "fee164", sortable: true, filter: true },
        { headerName: "Fee165", field: "fee165", sortable: true, filter: true },
        { headerName: "Fee166", field: "fee166", sortable: true, filter: true },
        { headerName: "Fee167", field: "fee167", sortable: true, filter: true },
        { headerName: "Fee168", field: "fee168", sortable: true, filter: true },
        { headerName: "Fee169", field: "fee169", sortable: true, filter: true },
        { headerName: "Fee170", field: "fee170", sortable: true, filter: true },
        { headerName: "Fee171", field: "fee171", sortable: true, filter: true },
        { headerName: "Fee172", field: "fee172", sortable: true, filter: true },
        { headerName: "Fee173", field: "fee173", sortable: true, filter: true },
        { headerName: "Fee174", field: "fee174", sortable: true, filter: true },
        { headerName: "Fee175", field: "fee175", sortable: true, filter: true },
        { headerName: "Fee176", field: "fee176", sortable: true, filter: true },
        { headerName: "Fee177", field: "fee177", sortable: true, filter: true },
        { headerName: "Fee178", field: "fee178", sortable: true, filter: true },
        { headerName: "Fee179", field: "fee179", sortable: true, filter: true },
        { headerName: "Fee180", field: "fee180", sortable: true, filter: true },
        { headerName: "Fee181", field: "fee181", sortable: true, filter: true },
        { headerName: "Fee182", field: "fee182", sortable: true, filter: true },
        { headerName: "Fee183", field: "fee183", sortable: true, filter: true },
        { headerName: "Fee184", field: "fee184", sortable: true, filter: true },
        { headerName: "Fee185", field: "fee185", sortable: true, filter: true },
        { headerName: "Fee186", field: "fee186", sortable: true, filter: true },
        { headerName: "Fee187", field: "fee187", sortable: true, filter: true },
        { headerName: "Fee188", field: "fee188", sortable: true, filter: true },
        { headerName: "Fee189", field: "fee189", sortable: true, filter: true },
        { headerName: "Fee190", field: "fee190", sortable: true, filter: true },
        { headerName: "Fee191", field: "fee191", sortable: true, filter: true },
        { headerName: "Fee192", field: "fee192", sortable: true, filter: true },
        { headerName: "Fee193", field: "fee193", sortable: true, filter: true },
        { headerName: "Fee194", field: "fee194", sortable: true, filter: true },
        { headerName: "Fee195", field: "fee195", sortable: true, filter: true },
        { headerName: "Fee196", field: "fee196", sortable: true, filter: true },
        { headerName: "Fee197", field: "fee197", sortable: true, filter: true },
        { headerName: "Fee198", field: "fee198", sortable: true, filter: true },
        { headerName: "Fee199", field: "fee199", sortable: true, filter: true },
        { headerName: "Fee200", field: "fee200", sortable: true, filter: true },
        {
          headerName: "recurringFeesEnabled",
          field: "recurringFeesEnabled",
          sortable: true,
          filter: true,
        },
        {
          headerName: "customProducts",
          field: "customProducts",
          sortable: true,
          filter: true,
        },
        {
          headerName: "enrollmentFees",
          field: "enrollmentFees",
          sortable: true,
          filter: true,
        },
      ],
      deleteColumnDefs: [
        {
          headerName: "Student Id",
          field: "studentId",
          sortable: true,
          filter: true,
          pinned: "left",
        },
        {
          headerName: "School Name",
          field: "schoolName",
          sortable: true,
          filter: true,
        },
        {
          headerName: "Merchant Id",
          field: "merchantId",
          sortable: true,
          filter: true,
        },
      ],
    };
  }
  componentDidMount() {
    $(".ag-cell").text("School Id").hide();
  }
  onPageSizeChanged(newPageSize) {
    var value = document.getElementById("page-size").value;
    this.gridApi.paginationSetPageSize(Number(value));
  }
  onGridReady = (params) => {
    params.api.setGridOption("rowData", this.props.details);
  };

  render() {
    return (
      <div className="uploadAGgridContainer" style={{ marginTop: 10 }}>
        <div style={{ marginBottom: 8 }}>
          <UploadSuccessMsg msg="Validation successfull!" />
        </div>
        <div
          style={{ height: "299px", width: "99%" }}
        >
          <AgGridReact
            modules={[
              ClientSideRowModelModule,
              ValidationModule,
              RowSelectionModule,
              TextFilterModule,
              NumberFilterModule,
              DateFilterModule,
              CustomFilterModule,
              PaginationModule,
            ]}
            columnDefs={
              this.props.isUpdateActive
                ? this.state.columnDefs
                : this.state.deleteColumnDefs
            }
            suppressMenuHide={true}
            rowData={this.props.details}
            onGridReady={this.onGridReady}
          ></AgGridReact>
        </div>
      </div>
    );
  }
}

UploadAGgrid.defaultProps = {
  details: [],
  isUpdateActive: false,
};

UploadAGgrid.propTypes = {
  details: PropTypes.array,
  isUpdateActive: PropTypes.bool,
};

export default UploadAGgrid;
